
<div productList = ''>
<!-- list-main-wrap-header-->
<div class="list-main-wrap-header fl-wrap block_box no-vis-shadow" *ngIf="router !== '/product-details'">
    <!-- <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <a href="#">{{departmentName}}</a>
            <a href="#" *ngIf="categoryName">&nbsp;<span class="black-text">>></span>&nbsp;{{categoryName}}</a>
        </ol>
        <ol class="breadcrumb search-string" *ngIf="searchString">
            <a href="#">Product contains any of these words</a>
            <ng-container *ngIf="allWords; else elseTemplate">
                    <a href="#" *ngIf="searchString">&nbsp;<span class="black-text">>></span>&nbsp;{{searchString.split(' ').toString()}}</a>
            </ng-container>
            <ng-template #elseTemplate>
                    <a href="#" *ngIf="searchString">&nbsp;<span class="black-text">>></span>&nbsp;{{searchString}}</a>  
            </ng-template>
        </ol>
    </nav> -->

    <!-- list-main-wrap-title-->
    <div class="list-main-wrap-title"> 
        <h2>Showing <span> 1–{{pagination}} </span> of {{totalCount}} results</h2>
    </div>
    <!-- list-main-wrap-title end-->
    <!-- list-main-wrap-opt-->
    <div class="list-main-wrap-opt">
        <!-- price-opt-->
        <div class="price-opt" *ngIf="totalCount">
            <span class="price-opt-title">Sort by:</span>
            <div class="listsearch-input-item ">
                <select class="form-select" id="sort-by" (change)="sortBy($event)" style="height: 40px; line-height: 28px;">
                    <option value="" selected disabled hidden>Sort By</option>
                    <option value="asc">Sort A-Z</option>
                    <option value="desc">Sort Z-A</option>
                    <option value="low">Price Low to High </option>
                    <option value="high">Price High to Low </option>
                  </select>
            </div>
        </div> 
        <!-- price-opt end-->
    </div>
    <!-- list-main-wrap-opt end-->
</div>
<!-- list-main-wrap-header end-->

<!-- listing-item-container -->
<div class="listing-item-container init-grid-items fl-wrap nocolumn-lic">
    <div *ngFor="let product of filteredProducts; track product | paginate: {itemsPerPage: itemsPerPage, currentPage: pagination, totalItems: totalCount };  let i = index;">
        <app-product-card [productData]="product"></app-product-card>
    </div>

    <!-- <div class="pagination fwmpag" *ngIf="router !== '/product-details'"></div>
        <pagination-controls (pageChange)="renderPage($event)"> </pagination-controls>
    </div> -->
    <div class="pagination fwmpag" *ngIf="totalCount">
        <pagination-controls (pageChange)="renderPage($event)"> </pagination-controls>
    </div>
</div>
<!-- listing-item-container end --> 
</div>
<div class="clearfix"></div>
<div class="alert alert-danger p-2 m-5" *ngIf="!totalCount">
    No record found.
</div>         